import { StoriesSection as StoriesSectionData } from '@7chairs/types';
import { isMobile } from 'react-device-detect';
import Carousel, { ResponsiveType, StateCallBack } from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import checkVerifiedCloudGray from '../../../../assets/checkVerifiedCloudGray.svg';
import starBlack from '../../../../assets/starBlack.svg';
import { useAnalytics } from '../../../../utils/analytics';
import {
  BREAKPOINTS,
  StoriesSectionStories,
  StoriesSectionStoryContent,
  StoriesSectionStoryMember,
  StoriesSectionStoryMemberAvatar,
  StoriesSectionStoryMemberIcon,
  StoriesSectionStoryMemberLabel,
  StoriesSectionStoryMemberLabelWrapper,
  StoriesSectionStoryMemberName,
  StoriesSectionStoryMemberRight,
  StoriesSectionStoryRating,
  StoriesSectionStoryStar,
  StoriesSectionStoryText,
  StoriesSectionStoryWrapper,
  StoriesSectionSubtitle,
  StoriesSectionTitle,
  StoriesSectionWrapper,
} from './StoriesSection.style';

const responsiveSettings: ResponsiveType = {
  desktop: {
    breakpoint: { max: BREAKPOINTS.DESKTOP_MAX, min: BREAKPOINTS.TABLET_WIDTH_START },
    items: 3,
  },
  tablet: {
    breakpoint: { max: BREAKPOINTS.TABLET_WIDTH_START, min: BREAKPOINTS.MOBILE1_WIDTH_START },
    items: 2,
    partialVisibilityGutter: 50,
  },
  mobile1: {
    breakpoint: { max: BREAKPOINTS.MOBILE1_WIDTH_START, min: BREAKPOINTS.MOBILE2_WIDTH_START },
    items: 1,
    partialVisibilityGutter: 200,
  },
  mobile2: {
    breakpoint: { max: BREAKPOINTS.MOBILE2_WIDTH_START, min: BREAKPOINTS.MOBILE3_WIDTH_START },
    items: 1,
    partialVisibilityGutter: 150,
  },
  mobile3: {
    breakpoint: { max: BREAKPOINTS.MOBILE3_WIDTH_START, min: 0 },
    items: 1,
    partialVisibilityGutter: 60,
  },
};

interface StoriesSectionProps {
  data: StoriesSectionData;
  withTitles?: boolean;
  withBottomBorder?: boolean;
}

export const StoriesSection = (props: StoriesSectionProps) => {
  const { data, withTitles = true, withBottomBorder = true } = props;

  const analytics = useAnalytics();

  const afterCarouselChange = (_previousSlide: number, state: StateCallBack) => {
    if (isMobile) {
      analytics.track('web paywall reviews swipe', { index: state.currentSlide });
    }
  };

  return (
    <StoriesSectionWrapper withBottomBorder={withBottomBorder}>
      {withTitles && (
        <>
          <StoriesSectionTitle>{data.title}</StoriesSectionTitle>
          <StoriesSectionSubtitle>{data.subtitle}</StoriesSectionSubtitle>
        </>
      )}
      <StoriesSectionStories withTitles={withTitles}>
        <Carousel
          responsive={responsiveSettings}
          arrows={false}
          partialVisible={true}
          afterChange={afterCarouselChange}
        >
          {data.stories.map((story, index) => (
            <StoriesSectionStoryWrapper key={index}>
              <StoriesSectionStoryContent>
                <StoriesSectionStoryRating>
                  {Array.from({ length: story.rating }).map((_, i) => (
                    <StoriesSectionStoryStar key={`${index}_${i}`} src={starBlack} />
                  ))}
                </StoriesSectionStoryRating>
                <StoriesSectionStoryText>{story.content}</StoriesSectionStoryText>
                <StoriesSectionStoryMember>
                  <StoriesSectionStoryMemberAvatar src={story.member.avatarUrl} />
                  <StoriesSectionStoryMemberRight>
                    <StoriesSectionStoryMemberName>{story.member.name}</StoriesSectionStoryMemberName>
                    <StoriesSectionStoryMemberLabelWrapper>
                      <StoriesSectionStoryMemberIcon src={checkVerifiedCloudGray} alt="" />
                      <StoriesSectionStoryMemberLabel>{story.member.sinceLabel}</StoriesSectionStoryMemberLabel>
                    </StoriesSectionStoryMemberLabelWrapper>
                  </StoriesSectionStoryMemberRight>
                </StoriesSectionStoryMember>
              </StoriesSectionStoryContent>
            </StoriesSectionStoryWrapper>
          ))}
        </Carousel>
      </StoriesSectionStories>
    </StoriesSectionWrapper>
  );
};
